var map = {
	"./avatar-bonnie-base-full.png": 4588,
	"./avatar-bonnie-dino-full.png": 36241,
	"./avatar-bonnie-fall-full.png": 53392,
	"./avatar-bonnie-smoothie-full.png": 91389,
	"./avatar-bonnie-space-full.png": 81779,
	"./avatar-bonnie-spring-full.png": 59132,
	"./avatar-bonnie-summer-full.png": 50628,
	"./avatar-bonnie-winter-full.png": 10248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80433;